import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Add = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 20 20" paths={['M17 10h-6V4h-1v6H4v1h6v6h1v-6h6z']} />
);

export default Add;
